module.exports = __webpack_public_path__ + "img/custom.308ffb80.png";